import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as ProfileCreators } from "model/profileModal"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { getFiltersVisible } from "modules/analyze-header/selectors"
import { getDetails, getSelected, getSelectedValue } from "./selectors"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    filtersVisible: getFiltersVisible(state, props),
    details: getDetails(state, props),
    selected: getSelected(state, props),
    selectedValue: getSelectedValue(state, props),
    ...state.modules.analyzePerformanceDetails,
  }),
  actions: {
    ...Creators,
    openSecurityProfile: ProfileCreators.openSecurityProfile,
    openFactorProfile: ProfileCreators.openFactorProfile,
    toggleShowNotHeld: PortfolioRootCreators.toggleShowNotHeld,
  },
})
